export default __webpack_public_path__ + "static/media/dash icon.0639cac5.svg";